const Config = {
  GoogleAPIKey: 'AIzaSyAEtGoT4q1ClrwVwL81wc9Z63LuiVPi50Q',
  GoogleAnalyticsID: 'UA-XXXXXX',
};

export default Config;